import { createClient } from '@supabase/supabase-js'
const supabaseUrl = 'https://siuqtbbuaijdkgozgvwx.supabase.co'
const supabaseKey = 'sb_publishable_to5SWpkTCM90SLre9Jclpw_IcueapXk'


export const supabase = createClient(supabaseUrl, supabaseKey)